import React, { useEffect, useRef } from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import FutureS1 from "../../components/futureS1";
import FutureS2 from "../../components/futureS2";
import {useParams} from "react-router-dom";
import { buildCrossDomainLink } from "../../utils/buildCrossDomainLink";
import {useDispatch} from "react-redux";
import {setInvitationCode} from "../../store/main/action";

const FuturePage = () => {
    const { t, i18n } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const requestStartedRef = useRef(false);

    const nextHomeUrl = buildCrossDomainLink({
        baseUrl: process.env.REACT_APP_NEXT_URL,
        path: '/',
        lang: i18n.language?.startsWith('ru') ? 'ru' : 'en',
    });

    useEffect(() => {
        const sendInviteCode = async () => {
            if (!id) return;

            const storageKey = 'inviteId';
            const savedInviteId = localStorage.getItem(storageKey);

            if (savedInviteId) {
                window.location.href = nextHomeUrl;
                return;
            }

            if (requestStartedRef.current) return;
            requestStartedRef.current = true;

            try {
                await dispatch(setInvitationCode(id));
            } catch (error) {
                console.error(error);
            } finally {
                localStorage.setItem(storageKey, id);
                window.location.href = nextHomeUrl;
            }
        };

        sendInviteCode();
    }, [id, dispatch, nextHomeUrl]);

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Future')}/>
            <FutureS1/>
            <FutureS2/>
        </section>
    );
};

export default FuturePage;